import * as XLSX from "xlsx";

export class SearchExport {
  // generate xlsx from an array of js objects
  exportToXlsx(name: string, processedData: any[]) {
    const ws: any = XLSX.utils.json_to_sheet(processedData);
    const wb: any = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Export");

    const wopts: any = { bookType: "xlsx", bookSST: false, type: "binary" };
    XLSX.writeFile(wb, name, wopts);
  }

  //genereate xlsx from array of js objects with auto size header
  //to eventually test as default method instead of exportToXlsx()
  exportToXlsxV2(name: string, processedData: any[]) {
    const indexes = [
      "A1",
      "B1",
      "C1",
      "D1",
      "E1",
      "F1",
      "G1",
      "H1",
      "I1",
      "J1",
      "K1",
      "L1",
      "M1",
      "N1",
      "O1",
      "P1",
      "Q1",
      "R1",
      "S1",
      "T1",
      "U1",
      "V1",
      "W1",
      "X1",
      "Y1",
      "Z1",
      "AA1",
      "AB1",
      "AC1",
      "AD1",
      "AE1",
      "AF1",
      "AG1",
      "AH1",
      "AI1",
      "AJ1",
      "AK1",
      "AL1",
      "AM1",
      "AN1",
      "AO1",
      "AP1",
      "AQ1",
      "AR1",
      "AS1",
      "AT1",
      "AU1",
      "AV1",
      "AW1",
      "AX1",
      "AY1",
      "AZ1",
      "BA1",
      "BB1",
      "BC1",
      "BD1",
      "BE1"
    ];
    const ws: any = XLSX.utils.json_to_sheet(processedData);
    if (!ws["!cols"]) ws["!cols"] = [];
    let count = 0;
    for (const keys in processedData[0]) {
      const xx = indexes[count];
      if (ws[xx]) ws[xx].v = keys;
      const size = { width: ws[xx] ? ws[xx].v.length + 2 : 10 + 2 };
      processedData.forEach(yy => {
        try {
          if (yy[xx] && yy[xx].length > size.width) {
            size.width = yy[xx].length + 1;
          }
        } catch (e) {
          console.error(e);
        }
      });
      ws["!cols"].push(size);
      count++;
    }
    const wb: any = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Export");

    const wopts: any = { bookType: "xlsx", bookSST: false, type: "binary" };
    XLSX.writeFile(wb, name, wopts);
  }

  //columns is a string array which contains the data headers
  exportArrayToXlsx(name: string, processedData: any[], columns: any[]) {
    //cells positions from whom to get the value width
    const indexes = [
      "A2",
      "B2",
      "C2",
      "D2",
      "E2",
      "F2",
      "G2",
      "H2",
      "I2",
      "J2",
      "K2",
      "L2",
      "M2",
      "N2",
      "O2",
      "P2",
      "Q2",
      "R2",
      "S2",
      "T2",
      "V2",
      "W2",
      "X2",
      "Y2",
      "Z2"
    ];
    //merging the columns for courier and client
    const mergeCourrier = XLSX.utils.decode_range("I1:N1");
    const mergeClient = XLSX.utils.decode_range("O1:T1");
    const ws: any = XLSX.utils.aoa_to_sheet(processedData);
    if (!ws["!merges"]) ws["!merges"] = [];
    ws["!merges"].push(mergeCourrier);
    ws["!merges"].push(mergeClient);
    //setting the auto width based on the data headers (columns: any[], positioned in indexes = [])
    if (!ws["!cols"]) ws["!cols"] = [];
    for (let i = 0; i < processedData[0].length; i++) {
      const xx = indexes[i];
      if (ws[xx]) ws[xx].v = columns[i];
      const size = { width: ws[xx] ? ws[xx].v.length + 2 : 10 + 2 };
      processedData.forEach(yy => {
        try {
          if (yy[xx] && yy[xx].length > size.width) {
            size.width = yy[xx].length + 1;
          }
        } catch (e) {
          console.error(e);
        }
      });
      ws["!cols"].push(size);
    }
    const wb: any = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Export");

    const wopts: any = { bookType: "xlsx", bookSST: false, type: "binary" };
    XLSX.writeFile(wb, name, wopts);
  }
}
